/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  GetAdminsMedicationsParams,
  ImageApiOutContract,
  MedicationAdminApiInContract,
  MedicationStaffApiOutContract,
  PostAdminsMedicationsImagesBody
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns 400 Bad Request when: no formulations are provided, duplicate formulations are provided, no fulfillment partner IDs are provided, or fulfillment partner IDs do not resolve to existing partners.
Returns 409 Conflict when a medication with matching identifiers already exists.
 * @summary Creates a new medication in the system.
 */
export const postAdminsMedications = (
    medicationAdminApiInContract: MedicationAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MedicationStaffApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/medications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: medicationAdminApiInContract, signal
    },
      options);
    }
  


export const getPostAdminsMedicationsMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsMedications>>, TError,{data: MedicationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminsMedications>>, TError,{data: MedicationAdminApiInContract}, TContext> => {

const mutationKey = ['postAdminsMedications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminsMedications>>, {data: MedicationAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAdminsMedications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminsMedicationsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminsMedications>>>
    export type PostAdminsMedicationsMutationBody = MedicationAdminApiInContract
    export type PostAdminsMedicationsMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Creates a new medication in the system.
 */
export const usePostAdminsMedications = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsMedications>>, TError,{data: MedicationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminsMedications>>,
        TError,
        {data: MedicationAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAdminsMedicationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */
export const getAdminsMedications = (
    params?: GetAdminsMedicationsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MedicationStaffApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/medications`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAdminsMedicationsInfiniteQueryKey = (params?: GetAdminsMedicationsParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/medications`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAdminsMedicationsQueryKey = (params?: GetAdminsMedicationsParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/medications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminsMedicationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedications>>> = ({ signal }) => getAdminsMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedications>>>
export type GetAdminsMedicationsInfiniteQueryError = void | ErrorApiOutContract


export function useGetAdminsMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetAdminsMedicationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedications>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedications>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetAdminsMedicationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */
export const prefetchGetAdminsMedicationsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsMedicationsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsMedicationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedications>>> = ({ signal }) => getAdminsMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedications>>>
export type GetAdminsMedicationsQueryError = void | ErrorApiOutContract


export function useGetAdminsMedications<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetAdminsMedicationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedications>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedications<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedications>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedications<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetAdminsMedications<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */
export const prefetchGetAdminsMedicationsQuery = async <TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsMedicationsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsMedicationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedications>>> = ({ signal }) => getAdminsMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedications>>>
export type GetAdminsMedicationsSuspenseQueryError = void | ErrorApiOutContract


export function useGetAdminsMedicationsSuspense<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetAdminsMedicationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsSuspense<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsSuspense<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetAdminsMedicationsSuspense<TData = Awaited<ReturnType<typeof getAdminsMedications>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsMedicationsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedications>>> = ({ signal }) => getAdminsMedications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedications>>>
export type GetAdminsMedicationsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetAdminsMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetAdminsMedicationsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves active medications, optionally filtered by a search term matching name, NDC, GCN, or alternative key.
 */

export function useGetAdminsMedicationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedications>>>, TError = void | ErrorApiOutContract>(
 params?: GetAdminsMedicationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedications>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieves a specific medication by its identifier.
 */
export const getAdminsMedicationsMedicationGlobalKey = (
    medicationGlobalKey: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MedicationStaffApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/medications/${encodeURIComponent(String(medicationGlobalKey))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminsMedicationsMedicationGlobalKeyInfiniteQueryKey = (medicationGlobalKey?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/medications/${medicationGlobalKey}`
    ] as const;
    }

export const getGetAdminsMedicationsMedicationGlobalKeyQueryKey = (medicationGlobalKey?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/medications/${medicationGlobalKey}`
    ] as const;
    }

    
export const getGetAdminsMedicationsMedicationGlobalKeyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsMedicationGlobalKeyInfiniteQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>> = ({ signal }) => getAdminsMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(medicationGlobalKey), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsMedicationGlobalKeyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>
export type GetAdminsMedicationsMedicationGlobalKeyInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetAdminsMedicationsMedicationGlobalKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsMedicationGlobalKeyInfiniteQueryOptions(medicationGlobalKey,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific medication by its identifier.
 */
export const prefetchGetAdminsMedicationsMedicationGlobalKeyInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, medicationGlobalKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsMedicationsMedicationGlobalKeyInfiniteQueryOptions(medicationGlobalKey,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsMedicationsMedicationGlobalKeyQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsMedicationGlobalKeyQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>> = ({ signal }) => getAdminsMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(medicationGlobalKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsMedicationGlobalKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>
export type GetAdminsMedicationsMedicationGlobalKeyQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>,
          TError,
          Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetAdminsMedicationsMedicationGlobalKey<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsMedicationGlobalKeyQueryOptions(medicationGlobalKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific medication by its identifier.
 */
export const prefetchGetAdminsMedicationsMedicationGlobalKeyQuery = async <TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, medicationGlobalKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsMedicationsMedicationGlobalKeyQueryOptions(medicationGlobalKey,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsMedicationsMedicationGlobalKeySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsMedicationGlobalKeyQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>> = ({ signal }) => getAdminsMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsMedicationGlobalKeySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>
export type GetAdminsMedicationsMedicationGlobalKeySuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetAdminsMedicationsMedicationGlobalKeySuspense<TData = Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsMedicationGlobalKeySuspenseQueryOptions(medicationGlobalKey,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsMedicationsMedicationGlobalKeySuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsMedicationsMedicationGlobalKeyInfiniteQueryKey(medicationGlobalKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>> = ({ signal }) => getAdminsMedicationsMedicationGlobalKey(medicationGlobalKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsMedicationsMedicationGlobalKeySuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>
export type GetAdminsMedicationsMedicationGlobalKeySuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetAdminsMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific medication by its identifier.
 */

export function useGetAdminsMedicationsMedicationGlobalKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 medicationGlobalKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsMedicationsMedicationGlobalKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsMedicationsMedicationGlobalKeySuspenseInfiniteQueryOptions(medicationGlobalKey,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns 400 Bad Request when: no formulations are provided, duplicate formulations are provided, no fulfillment partner IDs are provided, or fulfillment partner IDs do not resolve to existing partners.
Returns 404 Not Found when the medication does not exist or is inactive.
 * @summary Updates an existing medication.
 */
export const putAdminsMedicationsMedicationGlobalKey = (
    medicationGlobalKey: string,
    medicationAdminApiInContract: MedicationAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/medications/${encodeURIComponent(String(medicationGlobalKey))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: medicationAdminApiInContract
    },
      options);
    }
  


export const getPutAdminsMedicationsMedicationGlobalKeyMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsMedicationsMedicationGlobalKey>>, TError,{medicationGlobalKey: string;data: MedicationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsMedicationsMedicationGlobalKey>>, TError,{medicationGlobalKey: string;data: MedicationAdminApiInContract}, TContext> => {

const mutationKey = ['putAdminsMedicationsMedicationGlobalKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsMedicationsMedicationGlobalKey>>, {medicationGlobalKey: string;data: MedicationAdminApiInContract}> = (props) => {
          const {medicationGlobalKey,data} = props ?? {};

          return  putAdminsMedicationsMedicationGlobalKey(medicationGlobalKey,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsMedicationsMedicationGlobalKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsMedicationsMedicationGlobalKey>>>
    export type PutAdminsMedicationsMedicationGlobalKeyMutationBody = MedicationAdminApiInContract
    export type PutAdminsMedicationsMedicationGlobalKeyMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Updates an existing medication.
 */
export const usePutAdminsMedicationsMedicationGlobalKey = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsMedicationsMedicationGlobalKey>>, TError,{medicationGlobalKey: string;data: MedicationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsMedicationsMedicationGlobalKey>>,
        TError,
        {medicationGlobalKey: string;data: MedicationAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutAdminsMedicationsMedicationGlobalKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivates a medication (soft delete).
 */
export const deleteAdminsMedicationsMedicationGlobalKey = (
    medicationGlobalKey: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/medications/${encodeURIComponent(String(medicationGlobalKey))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminsMedicationsMedicationGlobalKeyMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsMedicationsMedicationGlobalKey>>, TError,{medicationGlobalKey: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsMedicationsMedicationGlobalKey>>, TError,{medicationGlobalKey: string}, TContext> => {

const mutationKey = ['deleteAdminsMedicationsMedicationGlobalKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminsMedicationsMedicationGlobalKey>>, {medicationGlobalKey: string}> = (props) => {
          const {medicationGlobalKey} = props ?? {};

          return  deleteAdminsMedicationsMedicationGlobalKey(medicationGlobalKey,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminsMedicationsMedicationGlobalKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminsMedicationsMedicationGlobalKey>>>
    
    export type DeleteAdminsMedicationsMedicationGlobalKeyMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Deactivates a medication (soft delete).
 */
export const useDeleteAdminsMedicationsMedicationGlobalKey = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsMedicationsMedicationGlobalKey>>, TError,{medicationGlobalKey: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminsMedicationsMedicationGlobalKey>>,
        TError,
        {medicationGlobalKey: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminsMedicationsMedicationGlobalKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Uploads a medication image and returns the URL to use in medication create/update calls.
 */
export const postAdminsMedicationsImages = (
    postAdminsMedicationsImagesBody: PostAdminsMedicationsImagesBody,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(postAdminsMedicationsImagesBody.image !== undefined) {
 formData.append(`image`, postAdminsMedicationsImagesBody.image)
 }

      return fetcher<ImageApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/medications/images`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostAdminsMedicationsImagesMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsMedicationsImages>>, TError,{data: PostAdminsMedicationsImagesBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminsMedicationsImages>>, TError,{data: PostAdminsMedicationsImagesBody}, TContext> => {

const mutationKey = ['postAdminsMedicationsImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminsMedicationsImages>>, {data: PostAdminsMedicationsImagesBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminsMedicationsImages(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminsMedicationsImagesMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminsMedicationsImages>>>
    export type PostAdminsMedicationsImagesMutationBody = PostAdminsMedicationsImagesBody
    export type PostAdminsMedicationsImagesMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Uploads a medication image and returns the URL to use in medication create/update calls.
 */
export const usePostAdminsMedicationsImages = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsMedicationsImages>>, TError,{data: PostAdminsMedicationsImagesBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminsMedicationsImages>>,
        TError,
        {data: PostAdminsMedicationsImagesBody},
        TContext
      > => {

      const mutationOptions = getPostAdminsMedicationsImagesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    